export const DEFAULT_TYPE = 'info'
export const OPTIONS = ['icon', 'id', 'source', 'type']
export const TYPES = ['error', 'info', 'success', 'warning']
